var getPageIdByUrl = function getPageIdByUrl(url) {
  var _a;

  return url ? (_a = url.match(/\/pages\/(\S*)\/index.html/)) === null || _a === void 0 ? void 0 : _a[1] : null;
};

function addIframeChildren(item, nextState, currentState) {
  var _ref;

  var _a, _b, _c, _d;

  if (Array.isArray((_a = item === null || item === void 0 ? void 0 : item.config) === null || _a === void 0 ? void 0 : _a.tabs) && !Object.is((_b = item === null || item === void 0 ? void 0 : item.config) === null || _b === void 0 ? void 0 : _b.tabs, (_d = (_c = currentState === null || currentState === void 0 ? void 0 : currentState[item.id]) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.tabs)) {
    var _Object$assign;

    var _item$config$tabs$red = item.config.tabs.reduce(function (init, val, index) {
      var pageId = getPageIdByUrl(val.tabUrl);

      if (pageId) {
        var id = "Iframe_" + pageId;
        init.childrens.push(id);
        init.components[id] = {
          render: 'Iframe',
          pid: item.id,
          id: id,
          config: {
            url: val.tabUrl,
            anchor: index,
            dynamic: false
          }
        };
      }

      return init;
    }, {
      childrens: [],
      components: {}
    }),
        childrens = _item$config$tabs$red.childrens,
        components = _item$config$tabs$red.components;

    return Object.assign((_Object$assign = {}, _Object$assign[item.id] = Object.assign(Object.assign({}, item), {
      childrens: childrens
    }), _Object$assign), components);
  }

  return _ref = {}, _ref[item.id] = item, _ref;
}

function updateConferenceHandler(partial, nextState, currentState) {
  return Object.keys(partial).reduce(function (init, key) {
    if (key.startsWith('Conference')) {
      Object.assign(init, addIframeChildren(partial[key], nextState, currentState));
    } else {
      init[key] = partial[key];
    }

    return init;
  }, {});
}

var checkIframeChildren = function checkIframeChildren(fn) {
  return function (originSet, get, api) {
    var set = function set(partial, replace) {
      var partialState = typeof partial === 'function' ? partial(get()) : partial;
      var nextState = replace ? partialState : Object.assign({}, get(), partialState);
      originSet(updateConferenceHandler(partialState, nextState, get()), replace);
    };

    api.setState = set;
    var initialState = fn(set, get, api);
    return initialState;
  };
};

export default checkIframeChildren;